<template>
  <div class="shipping-type">
    <div for="shippingType" v-if="hasShipping" class="mb-2">{{ $t("Shipping Type") }}</div>
    <v-layout wrap class="shipping-type-container" fill-height>
      <template v-if="charges">
        <template v-for="(charge, cindex) in charges">
          <v-flex
            xs6
            sm4
            md4
            lg3
            class="mb-1"
            :key="cindex"
            style="padding: 0; "
            v-if="
              ((charge.length > 0 && charge[1]) || charge.length == 1) &&
                cindex != 'additionalproduct_charge'
            "
          >
            <div
              class="shipping-type-item pa-1 pt-2 pb-2"
              style="height: 100%;border-radius: 5px;"
              :class="{ active: shippingType == cindex }"
              :style="{
                border: shippingType == cindex ? '2px solid ' + theme.color : '',
              }"
              @click="onSelect(cindex)"
            >
              <img
                :src="
                  require('../../assets/img/shipping/' +
                    (cindex.includes('other') ? 'other_charge' : cindex) +
                    '_logo.png')
                "
                :alt="cindex + 'logo'"
                style="max-width: 100%"
              />
              <div class="caption mt-2">
                <template v-if="isBearhouse && cindex.includes('other')"
                  >ห้องเย็น Inter Express</template
                >
                <template v-if="isRos && cindex.includes('cod_charge')"
                  >จ่ายที่ร้าน</template
                >
                <template v-else-if="cindex.includes('other')">
                  {{ charge[4] && !charge[4].includes("Other") ? charge[4] : $t(cindex) }}
                </template>
                <template v-else>{{ $t(cindex) }}</template>
              </div>
              <div :style="{ color: theme.color }">
                <div v-if="isBearhouse">
                  {{ currencySign }}{{ bearhouseshippingprice | decimalFormat }}
                </div>
                <div v-else-if="isCDS">
                  <div v-if="cdsshippingprice">
                    {{ currencySign }}{{ cdsshippingprice | decimalFormat }}
                  </div>
                  <div v-else>Free</div>
                </div>
                <div v-else-if="isKhaiwhan">
                  {{ currencySign }}{{ khaiwhanshippingprice | decimalFormat }}
                </div>
                <div v-else-if="pageProfile.type == 'fastdeli'">
                  {{ currencySign }}{{ customerShippingPrice | decimalFormat }}
                </div>

                <div v-else-if="charge[0] != 0 && isSmoothE">
                  <template v-if="total < 500"
                    >{{ currencySign }}{{ charge[0] | decimalFormat }}</template
                  >
                  <template v-else
                    >Free</template
                  >
                </div>
                <div class="text-xs-center" style="margin-top: 10px;" v-else-if="charge[0] != 0">
                  {{ currencySign }}{{ charge[0] | decimalFormat }}
                </div>
                <div class="text-xs-center" style="margin-top: 10px;" v-else>Free</div>
              </div>
            </div>
          </v-flex>
        </template>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config";
import axios from "axios";
export default {
  props: {
    value: {
      default: undefined,
    },
    pageid: {
      default: undefined,
    },
    additionalproduct_charge: {
      default: undefined,
    },
    shippinglist: {
      default: undefined,
    },
    bearhouseshippingprice: {
      default: undefined,
    },
    cdsshippingprice: {
      default: undefined,
    },
    khaiwhanshippingprice: {
      default: undefined,
    },
    total: {
      default: undefined,
    },
    customerShippingPrice: {
      default: undefined,
    },
  },
  data: function() {
    return {
      shippingType: undefined,
      charges: [],
      hasShipping: false,
    };
  },
  computed: {
    isCDS() {
      return this.pageProfile && this.$store.state.cds.includes(this.pageProfile.pageid);
    },
    ...mapGetters({
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    isKhaiwhan() {
      return this.pageProfile && this.$store.state.khaiwhan.includes(this.pageProfile.pageid);
    },
    isBearhouse() {
      return this.pageProfile && this.$store.state.bearhouse.includes(this.pageProfile.pageid);
    },
    isRos() {
      return this.pageProfile && this.$store.state.ros.includes(this.pageProfile.pageid);
    },
    isSmoothE() {
      return this.pageProfile && this.pageProfile.type == "smoothe";
    },
    currencySign: function() {
      if (this.pageProfile && this.pageProfile.pageid == "402026927063253") {
        return "$";
      } else if (this.pageProfile.pageid == "751241271893504") {
        return "K";
      } else {
        return "฿";
      }
    },
  },

  mounted: function() {
    var vm = this;

    if (vm.pageid) {
      // console.log(vm.shippinglist);
      vm.charges = vm.shippinglist;
      for (const cindex in vm.charges) {
        if (
          cindex != "additionalproduct_charge" &&
          vm.charges[cindex].length > 1 &&
          vm.charges[cindex][1]
        ) {
          vm.hasShipping = true;
        } else if (cindex != "additionalproduct_charge" && vm.charges[cindex].length == 1) {
          vm.hasShipping = true;
        }
      }
      for (var cindex in vm.charges) {
        if (
          cindex != "additionalproduct_charge" &&
          (vm.charges[cindex].length == 1 ||
            (vm.charges[cindex].length > 0 && vm.charges[cindex][1]))
        ) {
          vm.onSelect(cindex);
          return;
        }
      }
    }
  },
  methods: {
    onSelect: function(index) {
      this.shippingType = index;
      var shippingtype = {
        type: this.shippingType,
        value: this.charges[this.shippingType][0],
      };
      this.$emit("input", shippingtype);
      this.$emit("onChange", shippingtype);
    },

    getAllShippingCharge: function() {
      let vm = this;
      return new Promise((resolve, reject) => {
        let url = config.getConfig("serverUrl") + "allshipingcharge?pageid=" + vm.pageid;
        axios.get(url).then(
          (response) => {
            response = response.data;
            vm.charges = response.shippinglist;
            resolve();
          },
          (err) => {
            reject(err);
          }
        );
      });
    },
  },
  watch: {
    value: function(newVal) {
      if (newVal) {
        this.shippingType = newVal.type;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
